import { ENV } from '../../config/runtimeEnv';
import type { ProductVariant, CreateVariantParams, UpdateVariantParams } from '../../types/inventory/ProductTypes';
import { http } from '../../lib/http/client';

const API_BASE_URL = ENV.VITE_COMMERCE_SERVER;


// ─── API functions ────────────────────────────────────────────────────────────

/**
 * Fetch all variants for a product, ordered by position.
 * Returns fresh stock data including committed_quantity.
 */
export const fetchProductVariants = async (
    product_id: number
): Promise<ProductVariant[]> => {
    const response = await http.get(`${API_BASE_URL}/product-variants`, {
        params: { product_id },
    });
    return response.data.data;
};

/**
 * Create a new variant locally and sync to Shopify if the product is connected.
 */
export const createProductVariant = async (
    data: CreateVariantParams
): Promise<ProductVariant> => {
    const response = await http.post(`${API_BASE_URL}/product-variants`, data);
    return response.data;
};

/**
 * Update a variant locally and push changes to Shopify if connected.
 */
export const updateProductVariant = async (
    variant_id: number,
    data: UpdateVariantParams
): Promise<ProductVariant> => {
    const response = await http.put(
        `${API_BASE_URL}/product-variants/${variant_id}`,
        data
    );
    return response.data;
};

/**
 * Soft-delete a variant (marks inactive, removes Shopify IDs) and deletes it
 * from Shopify if connected. Returns 400 if it is the product's last variant.
 */
export const deleteProductVariant = async (variant_id: number): Promise<void> => {
    await http.delete(`${API_BASE_URL}/product-variants/${variant_id}`);
};